import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Form, Modal } from 'antd';

import SubareaForm from '../SubareaForm';
import { isEmpty } from 'lodash';
import { useUpdateSubArea } from '@/core/domain/operational/SubAreas/SubAreas.hooks';
import {
  SubArea,
  UpdateSubAreaRequest,
} from '@/core/domain/operational/SubAreas/SubAreas.types';

interface Props {
  visible: boolean;
  handleVisible: (subarea?: SubArea) => void;
  subarea?: SubArea;
}

const UpdateSubareaModal = ({ visible, handleVisible, subarea }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { areaId } = useRouteMatch<{ areaId: string }>().params;

  useEffect(() => {
    if (visible && !isEmpty(subarea)) {
      form.setFieldsValue({
        name: subarea?.name,
        active: subarea?.active,
      });
    }
  }, [visible, subarea]);

  const mutation = useUpdateSubArea();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj: UpdateSubAreaRequest = {
        ...values,
        executionOrder: 0, // TODO: Remover obrigatoriedade do campo no endpoint
        areaId,
        id: subarea?.id,
      };

      await mutation.mutateAsync(obj);

      handleCancel();
    } catch {}
  };

  const handleCancel = () => {
    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'areas.subareas.update' })}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={mutation.isLoading}
    >
      <SubareaForm form={form} isEdit />
    </Modal>
  );
};

export default UpdateSubareaModal;
